import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import ContentLoading from "components/common/ContentLoading";
import RoleName from "enums/RoleName";
import DataTableApiRespone from "interfaces/DataTableApiResponse";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import getBaseUrl from "utils/getBaseUrl";
import isInRole from "utils/isInRole";
import { MsalContext } from "../common/msal";

interface State {
    isLoading: boolean;
    isAdmin: boolean;
    data: UserSummary[];
    spinner: boolean;
    userName: string;
    errorMessage?: string;
}

interface UserSummary {
    id: number;
    name?: string;
    initials?: string;
    role?: string;
    email?: string;
    userName?: string;
}

export default class Index extends React.Component<RouteComponentProps<{}>, State> {
    private readonly baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;
    static contextType = MsalContext;
    context!: React.ContextType<typeof MsalContext>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.state = {
            isLoading: false,
            isAdmin: isInRole(RoleName.Admin),
            data: [],
            spinner: true,
            userName: '',
            errorMessage: undefined,
        };

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        //this.addUsers = this.addUsers.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>Users</BreadcrumbLink>
                </Breadcrumb>
                {this.state.errorMessage && (
                    <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                )}

                {this.state.isAdmin && <div className="button-group">
                    <Link to="/users/add" className="button__item"><i className="icon-users1"></i>Add Users</Link>
                </div>}
                <div className="card card--datatables">
                    <div className="card-block">
                        <h2 className="card__title">Users</h2>
                        <div className="datatable-wrapper">
                            <DataTable
                                ajaxUrl={this.baseUrl + "api/users/summary"}
                                useAuth={true}
                                ajaxData={this.dataTableData}
                                ajaxDataFilter={this.dataTableDataFilter}
                                onDraw={this.handleDataTableDraw}
                                ref={this.mainDataTableRef}
                                stateSave={true}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ width: "28%", textAlign: "center" }}>UserName</th>
                                        <th style={{ width: "27%", textAlign: "center" }}>Name</th>
                                        <th style={{ width: "10%", textAlign: "center" }}>Initials</th>
                                        <th style={{ width: "20%", textAlign: "center" }}>Role</th>
                                        <th style={{ width: "28%", textAlign: "center" }}>Email</th>
                                        {this.state.isAdmin && <th className="arrow-hidden" style={{ width: "1%", textAlign: "center" }}></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </DataTable>
                            {this.state.spinner ?
                                <ContentLoading />
                                :
                                <table className="d-none" ref={this.dataTableRef}>
                                    <tbody>
                                        {this.state.data.map((item, index) =>
                                            <tr key={item.id}>
                                                <td>{item.userName}</td>
                                                <td>{item.name}</td>
                                                <td>{item.initials}</td>
                                                <td>{item.role}</td>
                                                <td>{item.email}</td>
                                                {this.state.isAdmin && (item.userName !== this.state.userName) ? (<td>
                                                    <Link to={"/users/edit/" + item.id} className="btn-edit">
                                                        <i className="icon-edit1"></i>
                                                    </Link>
                                                    <a
                                                        className="btn-delete"
                                                        href="#"
                                                        data-id={item.id}
                                                    >
                                                        <i className="icon-delete1"></i>
                                                    </a>
                                                </td>) : (<td></td>)}
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    public componentDidMount() {
        document.title = "Users - " + SITE_NAME;

        const accounts = this.context.accounts;
        if (accounts.length > 0) {
            const account = this.context.accounts[0];
            if (account) {
                this.setState({
                    userName: account.username
                });
            }
        }
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "userName",
            "name",
            "initials",
            "role",
            "email"];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc"
                ? 1
                : 2,
            search: data.search.value,
            draw: data.draw,
        }

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiRespone<UserSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).find("a:not([href='#'])").click(e => {
            e.preventDefault();
            this.props.history.push($(e.currentTarget).attr("href")!);
        });
        $(dataTable)
            .find(".btn-delete")
            .click((e) => {
                e.preventDefault();
                this.deleteUser(parseInt($(e.currentTarget).attr("data-id")!, 10));
            });
    }

    private async deleteUser(id: number) {
        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            `users/${id}`,
            {
                method: "DELETE",
            },
            true
        );
        if (response.ok) {
            this.mainDataTableRef.current!.reload();
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/users/Index.tsx